import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  makeStyles,
  Typography
} from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ButtonWithSpinner from "../ButtonWithSpinner";
import toastError from "../../errors/toastError";

const useStyles = makeStyles((theme) => ({
  maxWidth: { width: "100%", padding: "0 0 20px 0", },

  floatingButton: {
    transition: "transform 0.3s",
    "&:hover": { transform: "translateY(-5px)", },
  }
}));

const QueueOverrideAuthorizationModal = ({
  open
  , onClose
  , queueOverride
  , handleResetStates
  , handleLoadQueueOverrides
}) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles();

  const [loading, setLoading] = useState(false);



  //  ***************
  //  ** Functions **
  //  ***************
  const handleClose = () => {
    onClose();
    setLoading(false);
  };

  const handleAuthorizeQueueOverride = async (isAuthorized) => {
    try {
      const { data } = await api.put(
        `/queueOverrides/${queueOverride.id}`
        , {
          ticketId: queueOverride.ticketId
          , requestedByUserId: queueOverride.requestedByUserId
          , isAuthorized
        }
      );

      if (data.success) {
        const toastMessage = isAuthorized
          ? "queueOverrideAuthorizationModal.toasts.successAuthorize"
          : "queueOverrideAuthorizationModal.toasts.successDeny";

        toast.success(i18n.t(toastMessage));
      }
      else {
        toast.info(i18n.t(data.message));
      }
    }
    catch (exception) {
      console.log("handleAuthorizeQueueOverride exception:", exception);
      toastError(exception);
    }
    finally {
      handleClose();
      handleResetStates();
      handleLoadQueueOverrides();
    }
  };



  //  ************
  //  ** Return **
  //  ************
  if (!queueOverride) return (<></>);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      scroll="paper"
    >
      <DialogTitle>
        {i18n.t("queueOverrideAuthorizationModal.title")}
      </DialogTitle>

      <DialogContent>
        <Typography gutterBottom component="h3">
          <b>{i18n.t("queueOverrideAuthorizationModal.texts.user")}</b> {queueOverride.requestUser.name}
        </Typography>

        <Typography gutterBottom component="h3">
          <b>{i18n.t("queueOverrideAuthorizationModal.texts.amountTickets")}</b> {queueOverride.ticketsWithRequestUser}
        </Typography>

        <br />
        <Divider />
        <br />

        <Typography gutterBottom component="h3">
          <b>{i18n.t("queueOverrideAuthorizationModal.texts.queuePositionAtRequest")}</b> {queueOverride.queuePositionAtRequest}
        </Typography>

        <Typography gutterBottom component="h3">
          <b>{i18n.t("queueOverrideAuthorizationModal.texts.requestReason")}</b> {queueOverride.requestReason}
        </Typography>
      </DialogContent>

      <DialogActions>
        <ButtonWithSpinner
          variant="outlined"
          color="inherit"
          loading={loading}
          className={classes.floatingButton}
          onClick={async () => await handleAuthorizeQueueOverride(false)}
        >
          {i18n.t("queueOverrideAuthorizationModal.buttons.deny")}
        </ButtonWithSpinner>

        <ButtonWithSpinner
          variant="contained"
          color="primary"
          loading={loading}
          className={classes.floatingButton}
          onClick={async () => await handleAuthorizeQueueOverride(true)}
        >
          {i18n.t("queueOverrideAuthorizationModal.buttons.authorize")}
        </ButtonWithSpinner>
      </DialogActions>
    </Dialog>
  );
};

export default QueueOverrideAuthorizationModal;
